import { render } from "./userList_ip.vue?vue&type=template&id=a23e87ec&scoped=true"
import script from "./userList_ip.vue?vue&type=script&lang=js"
export * from "./userList_ip.vue?vue&type=script&lang=js"

import "./userList_ip.vue?vue&type=style&index=0&id=a23e87ec&scoped=true&lang=css"

import exportComponent from "/Users/cole/.codex/worktrees/jwt-cookie-expiry/tcd-cube_opr/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a23e87ec"]])

export default __exports__